module.exports = __webpack_public_path__ + "img/lock_channel.c36d544e.gif";